(() => {
  if (window.__yoCollectionVariantAvailabilityInstalled) return;
  window.__yoCollectionVariantAvailabilityInstalled = true;

  const CARD_SELECTOR = '.spf-product-card';
  const SWATCH_SELECTOR = '.spf-product__swatch[data-option]';
  // This catalogue uses option 1 for Color, followed by Size.
  const COLOR_OPTION_ORDER = '1';
  const VARIANT_SELECTOR = 'select.spf-product__variants option';

  function selectedValues(card) {
    const values = {};
    card.querySelectorAll(`${SWATCH_SELECTOR}.is-selected`).forEach((swatch) => {
      values[swatch.dataset.option] = swatch.dataset.optionValue;
    });
    return values;
  }

  function variantMatches(option, selected, optionOrder, optionValue) {
    if (option.getAttribute(`data-option${optionOrder}`) !== optionValue) return false;
    // A color is sold out only when NO size of that color is available.
    // Size availability still depends on the currently selected color.
    if (optionOrder === COLOR_OPTION_ORDER) return true;
    return Object.entries(selected).every(([order, value]) =>
      order === optionOrder || option.getAttribute(`data-option${order}`) === value
    );
  }

  function applyAvailability(card) {
    const variants = Array.from(card.querySelectorAll(VARIANT_SELECTOR));
    if (!variants.length) return;

    const selected = selectedValues(card);
    card.querySelectorAll(SWATCH_SELECTOR).forEach((swatch) => {
      const order = swatch.dataset.option;
      const value = swatch.dataset.optionValue;
      const available = variants.some((variant) =>
        variant.getAttribute('data-available') === 'true' &&
        variantMatches(variant, selected, order, value)
      );
      swatch.classList.toggle('soldout', !available);
      const disabled = String(!available);
      if (swatch.getAttribute('aria-disabled') !== disabled) {
        swatch.setAttribute('aria-disabled', disabled);
      }
    });
  }

  function applyWithin(root) {
    if (!(root instanceof Element) && root !== document) return;
    if (root.matches?.(CARD_SELECTOR)) applyAvailability(root);
    root.querySelectorAll?.(CARD_SELECTOR).forEach(applyAvailability);
  }

  function scheduleCard(card) {
    if (!card) return;
    window.requestAnimationFrame(() => applyAvailability(card));
    window.setTimeout(() => applyAvailability(card), 80);
  }

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest?.(SWATCH_SELECTOR);
    if (swatch) scheduleCard(swatch.closest(CARD_SELECTOR));
  });

  // Globo can update soldout/is-selected after click handlers and after
  // filtering/pagination. Reconcile those changes, not just newly added cards.
  const pendingCards = new Set();
  let pendingFrame = 0;
  function queueCard(card) {
    if (!card) return;
    pendingCards.add(card);
    if (pendingFrame) return;
    pendingFrame = window.requestAnimationFrame(() => {
      pendingFrame = 0;
      const cards = Array.from(pendingCards);
      pendingCards.clear();
      cards.forEach((card) => { if (card.isConnected) applyAvailability(card); });
    });
  }

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') {
        if (record.target.matches(SWATCH_SELECTOR) || record.target.matches(VARIANT_SELECTOR)) {
          queueCard(record.target.closest(CARD_SELECTOR));
        }
      } else {
        record.addedNodes.forEach((node) => applyWithin(node));
      }
    });
  });

  function start() {
    applyWithin(document);
    observer.observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['class', 'data-available']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.YaelCollectionVariantAvailability = { applyAvailability };
})();
